<template>
  <v-row class="fill-height" no-gutters>
    <v-col class="filter-column pa-3" cols="3">
      <div class="breadcrumbs my-3">
        <div class="breadcrumb active" @click="clickPath(-1)">
          <a>All</a>
          <div class="mx-3" v-if="path.length > 0">/</div>
        </div>
        <div
          class="breadcrumb active"
          v-for="(value, index) in path"
          :key="value"
          @click="clickPath(index)"
        >
          <a>{{value}}</a>
          <div class="mx-3" v-if="index != path.length - 1">/</div>
        </div>
      </div>
      <v-divider class="my-3"></v-divider>
      <v-text-field v-model="search" label="Search" outlined dense hide-details></v-text-field>
      <v-divider class="my-3"></v-divider>
      <div class="filters">
        <div v-for="filter in filters" :key="filter.name">
          <my-filter :filter="filter"></my-filter>
          <v-divider></v-divider>
        </div>
      </div>
    </v-col>
    <v-col cols="9" class="pa-3">
      <div v-if="theGroups.length <= 0" class="empty-groups">
        <v-icon size="150">mdi-view-grid-outline</v-icon>
        <div>There are no products that match the current filters...</div>
      </div>
      <div v-else>
        <v-row no-gutters>
          <v-col
            v-for="(group, index) in theGroups"
            :key="group.pageNumber"
            cols="12"
            md="4"
            xl="3"
            class="pa-3"
          >
            <group :group="group" :index="index"></group>
          </v-col>
        </v-row>
        <v-pagination v-model="page" :length="paginationLength" total-visible="9"></v-pagination>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import MyFilter from "../components/MyFilter.vue";
import Group from "../components/Group.vue";
import _ from "lodash";

export default {
  components: {
    MyFilter,
    Group
  },
  data: function() {
    return {};
  },
  computed: {
    path: function() {
      return this.$store.state.path;
    },
    currentNode: function() {
      return this.$store.getters.currentNode;
    },
    search: {
      get: function() {
        return this.$store.state.search;
      },
      set: _.debounce(function(value) {
        this.$store.commit("setSearch", value);
      }, 1000)
    },
    filters: function() {
      return this.$store.getters.filters;
    },
    config: function() {
      return this.$store.state.config;
    },
    filteredGroups: function() {
      return this.$store.getters.filteredGroups;
    },
    theGroups: function() {
      return this.$store.getters.theGroups;
    },
    page: {
      get: function() {
        return this.$store.state.page;
      },
      set: function(value) {
        this.$store.commit("setPage", value);
      }
    },
    paginationLength: function() {
      return Math.ceil(
        this.filteredGroups.length / this.$store.state.groupsPerPage
      );
    }
  },
  methods: {
    clearPath() {
      this.$store.commit("clearPath");
    },
    clickPath(index) {
      this.$store.commit("setPath", index);
      this.$router.push(
        `/Manufacturers/${this.$route.params.manufacturerId}/Avenue/Path`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  justify-content: center;
  align-items: center;
  //text-transform: uppercase;

  .breadcrumb {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}

.empty-groups {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.54);
  font-size: 24px;
}
.groups {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  .group {
    margin: 10px;
  }
}

.filters {
  .filter {
    margin: 10px;
    margin-bottom: 20px;
  }
}

.filter-column {
  background-color: white;
}
</style>
